// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type KontaktaufnahmeTranskript } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetKontaktaufnahmeTranskript(): (
  kontaktaufnahmeId: string
) => Promise<KontaktaufnahmeTranskript> {
  const getAPI = useGetApi();
  return useCallback(
    async (kontaktaufnahmeId) =>
      (await getAPI()).kontaktaufnahme.getKontaktaufnahmeTranskript({
        kontaktaufnahmeId,
      }),
    [getAPI]
  );
}
